// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 223) return "static/chunks/223-8fd535e42a4ca74d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1294 ? "1fdf8d55" : chunkId) + "." + {"1294":"96f7ef23ecf029e3","4520":"3ff1651ff6a9e328","5610":"93e3e2ab27743416","8611":"fd5d81bc1e39d923"}[chunkId] + ".js";
};